@if (shouldRenderLangSelection && _visibility()) {
  <div class="lang-section">
    @for (lang of _languages; track lang) {
      <a
        role="button"
        tabindex="0"
        acNavigationLink
        [class.active]="lang.lang === _currentLangSig()"
        [attr.negative]="side ? side : null"
        (click)="setLanguage(lang.lang)"
        (keydown.enter)="setLanguage(lang.lang)"
        (keydown.space)="setLanguage(lang.lang)"
      >
        {{ lang.label | translate | uppercase }}
      </a>
    }
  </div>
}
